import React from 'react';
import { Dialog, IconButton, DialogTitle, DialogContent, DialogActions, Divider, makeStyles, Button} from '@material-ui/core';
import closeIcon from "../../images/closeIcon.svg"
import warningIcon from "../../images/warningIcon.svg"

const useStyles = makeStyles({
    divider:{
        backgroundColor: "#000"
    },
    dialogActions:{
        padding: "0.5rem 1.5rem 1.5rem 1.5rem", 
        display: "flex", 
        alignItems: "center", 
        columnGap: "1rem"
    }
})

function AdminDialog(props) {
    const {operation, title, open, onClose, handleOnClick, dialogSize } = props;
    const styles = useStyles();

    const dialogStyles = {
        width: operation !== 'delete' ? (dialogSize?.width || '550px') : '550px',
        height: operation !== 'delete' ? (dialogSize?.height || '180px') : null,
    };

    return (
        <Dialog PaperProps={{square: true}} maxWidth={"xl"} open = {open} onClose = {onClose}>
            <div style = {dialogStyles}>
                {operation === "delete" && <div className='warning-bar'></div>}
                <DialogTitle disableTypography className="titleStyles">
                    {operation === 'delete' 
                    ? <span className='warning-label'><img height={17} src={warningIcon} title={"Advertencia"}/><span>Advertencia</span></span>
                    : <span>{title}</span>}
                    <IconButton size='small' onClick = {onClose}><img height={15} src={closeIcon} title={"Cerrar"}/> </IconButton>
                </DialogTitle>
                <Divider classes={{root: styles.divider}} orientation='horizontal'/>
                <DialogContent>
                    {props.children}
                </DialogContent>
                <DialogActions classes={{root: styles.dialogActions}} style={{justifyContent: operation !== 'delete' ? "space-between" : "flex-end"}}>
                    {operation === 'delete' ? 
                        <>
                            <Button onClick={handleOnClick} color='primary' variant='contained'>Aceitar</Button>      
                            <Button onClick={onClose} color='primary' variant='outlined' >Cancelar</Button>              
                        </>
                    : 
                        <>
                            <Button onClick={onClose} color='primary' variant='outlined' >Cancelar</Button> 
                            <Button onClick={handleOnClick} color='primary' variant='contained'>Salvar</Button>
                        </>
                    }
                </DialogActions>
            </div>
        </Dialog>
    );
}

export default AdminDialog;